// Localized copy for the shared DOM game-state overlay
// (`@bn-games/ui-shell`'s `createGameStateOverlay`). The game-over state is
// worded like a local game's — who won, and how.
import type { GameStateOverlayLabels } from '@bn-games/ui-shell';
import { t } from '../i18n/I18n.js';
import { resultTitle, terminationText, type GameOverView } from '../scenes/GameOverHost.js';

export function buildOnlineOverlayLabels(result: GameOverView | null): GameStateOverlayLabels {
  const none = { title: '' };
  return {
    // Never shown: an opponent dropping is a banner in chess, not an overlay.
    opponentDisconnected: () => none,
    reconnectingSelf: (countdown) => ({
      title: t('online.overlay.reconnecting'),
      body: t('online.overlay.restoringGame', { countdown }),
    }),
    gameDisconnected: () => ({
      title: t('online.overlay.connectionLost'),
      body: t('online.overlay.gameEnded'),
    }),
    rematchOffered: (name) => ({
      title: t('online.overlay.rematchOffered'),
      body: t('online.overlay.waitingForOpponent', { name }),
    }),
    rematchRequested: (name) => ({ title: t('online.overlay.rematchRequested', { name }) }),
    rematchDeclined: (name) => ({ title: t('online.overlay.rematchDeclined', { name }) }),
    gameOver: () =>
      result === null ? none : { title: resultTitle(result), body: terminationText(result.outcome.termination) },
    buttons: {
      leave: t('online.overlay.buttons.leave'),
      rematch: t('online.overlay.buttons.rematch'),
      'return-to-menu': t('online.overlay.buttons.returnToMenu'),
      cancel: t('online.overlay.buttons.cancel'),
      accept: t('online.overlay.buttons.accept'),
      decline: t('online.overlay.buttons.decline'),
    },
  };
}
